import React from "react";
export default function () {
    return (
        <svg width="200" height="200" viewBox="0 0 200 200">
            <g>
                <path d="M33.2,88.7c-2.7-4.7-10.7-5.4-17.9-1.6S4.4,97.8,7,102.5s10.7,5.4,18,1.6S35.9,93.4,33.2,88.7Z" />
                <rect x="32.1" y="21.2" width="1.9" height="71.82" />
            </g>
            <circle cx="47" cy="93" r="4" />
        </svg>
    );
}
